<template>
  <material-card
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    :title="$t('globals.drugs')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="local_hospital"
  >
    <drug-list :cms="cms"></drug-list>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import DrugList from "../components/Drugs/DrugList";
import { planSetter } from "../mixins/planSetter";
import { mapGetters } from "vuex";

export default {
  components: { DrugList },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  data: () => ({
    cms: null
  }),
  mounted() {
    this.cms = this.$router.currentRoute.params.cms;
    console.log(this.cms);
  },
};
</script>
